/* CSS */
import "@js/parts/forms";

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR');
    });
}

import Forms from '@js/modules/Forms';

window.FORMS =
    window.FORMS ||
    new (function FORMS() {

        this.modules = {
            Forms: Forms,
        };

    })();
